export default {
  setCurrentWalletProvider (state, value) {
    state.currentWalletProvider = value
  },
  setCurrentWeb3 (state, value) {
    state.currentWeb3 = value
  },
  setCurrentNetwork (state, value) {
    state.currentNetwork = value
  },
  setIsWalletConnected (state, value) {
    state.isWalletConnected = value
  },
  setWallets (state, payload) {
    state.wallets = payload
  },
  setTokensAssetsProfile (state, payload) {
    state.tokensAssetsProfile = payload
  },
  setTokensInfo (state, payload) {
    state.tokensInfo = payload
  },
  setTokensWithBalance (state, payload) {
    state.tokensWithBalance = Object.assign({}, payload)
  },
  setTokensAvaliable (state, payload) {
    state.tokensAvaliable = payload
  },
  setCurrentBestRate (state, payload) {
    state.currentBestRate = payload
  },
  increaseGetBestRateCount (state) {
    state.getBestRateCount++
  },
  setTransactionHistory (state, payload) {
    const newPayload = payload.map(p => ({ ...p, type: 'TRADING' }))
    state.transactionHistory = newPayload
    localStorage.setItem(`KULAP.transaction-history-${state.currentNetwork}-${state.wallets[0]}`, JSON.stringify(newPayload))
  },
  pushTransactionHistory (state, payload) {
    payload.type = 'TRADING'
    const isExist = !!state.transactionHistory.find(tx => tx.transactionHash === payload.transactionHash)
    if (isExist) {
      const index = state.transactionHistory.findIndex(tx => tx.transactionHash === payload.transactionHash)
      if (payload.hasOwnProperty('status')) {
        state.transactionHistory[index].status = payload.status
      }
      if (payload.hasOwnProperty('fromAmount')) {
        state.transactionHistory[index].fromAmount = payload.fromAmount
      }
      if (payload.hasOwnProperty('toAmount')) {
        state.transactionHistory[index].toAmount = payload.toAmount
      }
    } else {
      const temp = state.transactionHistory
      temp.push(payload)
      state.transactionHistory = temp
    }
    if (payload.status === 'in progress') {
      state.unreadTxHistoryAmount = state.unreadTxHistoryAmount + 1
      state.notiUnread.push(payload.transactionHash)
      localStorage.setItem(`KULAP.unread-tx-history-amount-${state.currentNetwork}-${state.wallets[0]}`, state.unreadTxHistoryAmount)
      localStorage.setItem(`KULAP.unread-noti-${state.currentNetwork}-${state.wallets[0]}`, JSON.stringify(state.notiUnread))
    }
    localStorage.setItem(`KULAP.transaction-history-${state.currentNetwork}-${state.wallets[0]}`, JSON.stringify(state.transactionHistory))
  },
  setUnreadTxHistoryAmount (state, payload) {
    state.unreadTxHistoryAmount = payload
  },
  setUnreadUserNotiAmount (state, payload) {
    state.unreadUserNotiAmount = payload
  },
  markTxHistoryAsUnread (state, payload) {
    state.notiUnread = payload
  },
  setUser (state, user) {
    state.user = user
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js